import requirementCompletionDetails from 'modules/requirements/RequirementCompletionDetails/slices/requirementCompletionDetails'
import requirements from 'modules/requirements/Requirements/slices/requirements'

const slices = {
  requirements,
  requirementCompletionDetails,
}

export default slices
